import React, { useState, useEffect } from "react";
import Routes from './routes'
import { useLocation,   
    BrowserRouter as Router,
    Route } from 'react-router-dom'

export default function App (){
   
    return <Routes/>
 
}